/* Ott-common */
import { Errors } from '@dtvgo/player-utils';

/* Utils */
import { REPORT_GA } from './constants';
import { gaServiceError } from '../services/gaService';

const ERROR_EVENT_CATEGORY = {
  [Errors.ErrorCode.BLACKOUT]:
    REPORT_GA.GA_ERROR_EVENT_CATEGORY_BLACKOUT,
  [Errors.ErrorCode.NOT_IN_PACKAGE]:
    REPORT_GA.GA_ERROR_EVENT_CATEGORY_ENTITLEMENTS,
  [Errors.ErrorCode.CONCURRENCY_PER_USER]:
    REPORT_GA.GA_ERROR_EVENT_CATEGORY_CONCURRENCY,
  [Errors.ErrorCode.CONCURRENCY_PER_CHANNEL]:
    REPORT_GA.GA_ERROR_EVENT_CATEGORY_SIMULTANEOUS_PLAYBACK,
};

function trackGAInterstitialError(isInterstitialCurrentScheduleError) {
  if (isInterstitialCurrentScheduleError !== undefined) {
    if (isInterstitialCurrentScheduleError) {
      gaServiceError.sendEvent({
        action: REPORT_GA.GA_EVENT_ACTION_BUTTON_CLICK,
        label: REPORT_GA.GA_ERROR_EVENT_LABEL_AFTER_EVENT_INTERSTITIAL,
        category: REPORT_GA.GA_EVENT_CATEGORY_INTERSTITIAL,
      });
    } else {
      gaServiceError.sendEvent({
        action: REPORT_GA.GA_EVENT_ACTION_BUTTON_CLICK,
        label: REPORT_GA.GA_ERROR_EVENT_LABEL_BEFORE_EVENT_INTERSTITIAL,
        category: REPORT_GA.GA_EVENT_CATEGORY_INTERSTITIAL,
      });
    }
  }
}

export function trackGAErrorMessagePlayer({
  error,
  title,
  subtitle,
  sourceProvider,
  isFromInterstitial,
  isInterstitialCurrentScheduleError,
}) {
  if (isFromInterstitial) {
    trackGAInterstitialError(isInterstitialCurrentScheduleError);
  }

  gaServiceError.sendEvent({
    action: REPORT_GA.GA_ERROR_EVENT_ACTION_ERROR_RECEIVED,
    label: [title, subtitle].filter(Boolean).join(' '),
    category: ERROR_EVENT_CATEGORY[error.code] || REPORT_GA.GA_ERROR_EVENT_CATEGORY_PLAYBACK,
  }, {
    sourceProvider,
  });
}

export function trackGAErrorMessageButton(error) {
  gaServiceError.sendEvent({
    action: REPORT_GA.GA_EVENT_ACTION_BUTTON_CLICK,
    label: REPORT_GA.GA_EVENT_LABEL_NA,
    category: ERROR_EVENT_CATEGORY[error.code] || REPORT_GA.GA_ERROR_EVENT_CATEGORY_PLAYBACK,
  });
}
